<template>
  <v-cotainer fluid grid-list-md fill-height >
    <v-layout row wrap>
      <v-flex xs12 sm12 md12>
        <v-toolbar class="primary white--text">
            <v-toolbar-title class="text-xs-center">
              To Do List
            </v-toolbar-title>
            <v-spacer></v-spacer>   
            <v-btn outlined @click="todoDialog = true">
              <v-icon left color="teal">add</v-icon> New To Do List
            </v-btn>
        </v-toolbar>

        <v-data-table
          :headers="todoHeader"
          :items="todosByBrand"
          hide-actions
          class="elevation-1 dashboardHead"
        >
          <template slot="items" slot-scope="props">
            <!-- <td>
              <v-icon :disabled="getCustomerName(props.item.buyerId) == 'DELETED CUSTOMER'" @click="openProd(props.item)" color="primary">remove_red_eye</v-icon>
            </td> -->
            <td>
              <b>{{new Date(props.item.date).toLocaleDateString('en-GB')}}</b>
            </td>
            <td>
              <b>{{props.item['todoNumber']}}</b>
            </td>
            <td>
              <b>{{props.item['todoContent']}}</b>
            </td>
             
            <!-- <td>
              <b>{{getCustomerName(props.item.buyerId)}}</b>
            </td> -->
            <td>
              <v-btn icon class="mx-0" v-if="props.item['status'] == 'IN PROGRESS'" @click="editTodo(props.item)">
                <v-icon color="pink">edit</v-icon>
              </v-btn>
            </td>
            <td>
              <v-btn icon class="mx-0" @click="deleteTodo(props.item)">
                <v-icon color="pink">delete</v-icon>
              </v-btn>
            </td>
          </template>
          <template slot="no-data">No Items</template>
        </v-data-table>
      </v-flex>
    </v-layout>
    
    <!-- Start Product Transfer Dialog -->
    <v-dialog v-model="todoDialog" persistent max-width="1000px">
      <v-card persistent>
        <v-card-title class="primary white--text">
          <span class="headline" v-if="isEdit">Edit Todo List</span>
          <span class="headline" v-else>Create Todo List</span>
            <v-spacer></v-spacer>
          </v-card-title>

          <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
            <!-- <v-flex xs12 sm12 md12>
              <v-switch
                :disabled="isEdit"
                v-model="isBuyer"
                :label="`${isBuyer ? 'Customer To Do List' : 'Supplier To Do List'}`"
              ></v-switch>
            </v-flex> -->
            <!-- <v-flex xs12 sm4 md4>
            <v-select
              dense
              :items="firmsByBrand"
              label="Select Firm"
              v-model="selectedFirm"
            ></v-select>
            </v-flex>

           <v-flex xs12 sm4 md4>
           <v-select 
                v-bind:items="isBuyer ? buyersByBrand : sellersByBrand"
                v-model="selectedBuyer" 
                :label="isBuyer ? 'Select or add Buyer' : 'Select or add Seller'"
                autocomplete
                :disabled="isEdit"
                item-text="name"
                return-object
                @keyup.native.enter="addCustomer"
            >   
           </v-select>
        </v-flex> -->
            
        <v-flex xs12 sm2 md2>
          <v-menu
            :close-on-content-click="false"
            v-model="datepickerTodo"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <v-text-field
              slot="activator"
              v-model="date"
              label="To Do List Date"
              prepend-icon="event"
              readonly
            ></v-text-field>
            <v-date-picker v-model="date" @input="datepickerTodo = false"></v-date-picker>
          </v-menu>
        </v-flex>

        <v-flex xs12 sm4 md4>
          <v-text-field
            v-model="todoNumber"
            prefix="#"
            label="Purpose"
            placeholder="Enter Purpose"
            required
          ></v-text-field>
        </v-flex>
        <v-flex xs12 sm12 md12>
            <v-textarea 
               background-color="grey darken-1"
               color="black"
               label="Enter Content To Remember" 
               box 
               v-model="todoContent" >
            </v-textarea>
        </v-flex>  

        </v-layout>
        </v-container>
        </v-card-text>
        <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                @click="todoDialog = false"
                flat
              >Cancel</v-btn>
              <v-btn
                color="blue darken-1"
                @click="addTodo()"
                flat
              >{{isEdit ? 'Save' : 'Create' }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="invoiceTodo" width="800" v-if="selectedTodo && selectedTodo['.key']">
        <v-card>
          <v-card-title class="headline grey lighten-2" primary-title>To Do List Content 
          </v-card-title>
          <v-divider></v-divider>
          <v-card-title>  
            {{selectedTodo['todoContent']}}
          </v-card-title>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="invoiceTodo = false">Confirm</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
  </v-cotainer>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
const mapGlobalGetters = createNamespacedHelpers("Global")["mapGetters"];
const mapBuyerGetters = createNamespacedHelpers("Buyer")["mapGetters"];
export default {
  data() {
    return {
      productsToTodo : [],
      items:[],
      isEdit:false,
      todoDialog: false,
      isBuyer : true,
      invoiceTodo : false,
      historyStep: 1,
      selectedTodo : null,
      selectedBuyer : null,
      selectedFirm : null,
      date:  new Date().toISOString().substr(0, 10),
      datepickerTodo: false,
      statusFilter : 'ALL',
      todoNumber: null,
      todoHistory : false,
      todoContent : null,
      modalMode:null,
      todoHeader: [
        { text: "Date", value: "date" },
        { text: "Purpose", value: "todoNumber" },
        { text: "Content", value: "date", sortable: true },  
        { text: "Edit", value: "edit" },
        { text: "Delete", value: "edit" },
      ],
      productInvoiceHeader: [
        { text: "Name", value: "Name" },
        { text: "Quantity", value: "Taxable" },
        { text: "Unit", value: "HSN" },
        { text: "Rate", value: "rate" },
        { text: "Total", value: "total" },
      ]
    };
  },
  created() {
    this.$bindAsArray("buyers", this.$root.$firebaseRefs.buyer.orderByChild('brand').equalTo(this.selectedBrand)),
    this.$bindAsArray("sellers", this.$root.$firebaseRefs.seller.orderByChild('brand').equalTo(this.selectedBrand)),
    this.$bindAsArray('firms', this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand)),
    this.$bindAsArray("todos", this.$root.$firebaseRefs.todos.orderByChild('brand').equalTo(this.selectedBrand)),
    this.$bindAsObject('buyerById', this.$root.$firebaseRefs.buyer.orderByChild('brand').equalTo(this.selectedBrand)),
    this.$bindAsObject('sellerById', this.$root.$firebaseRefs.seller.orderByChild('brand').equalTo(this.selectedBrand))
  },
  computed: {
    ...mapGlobalGetters(["selectedBrand",'finYear']),
    ...mapGlobalGetters({ units: "productUnit" }),
    
    todosByBrand(){
      return this.todos.filter(
        item => {
          return (item["brand"] === this.selectedBrand 
          && (this.statusFilter != 'ALL' ? item.status == this.statusFilter : true))
        }
      );
    },
    buyersByBrand(){
      return this.buyers
        .filter(item => {
          return (
            item["brand"] === this.selectedBrand
          );
        })
    },
    sellersByBrand(){
      return this.sellers
        .filter(item => {
          return (
            item["brand"] === this.selectedBrand
          );
        })
    },
    firmsByBrand() {
      return this.firms
        .filter(item => item["brand"] === this.selectedBrand)
        .map(item => {
          if (item.defaultFirm) {
            this.selectedFirm = item[".key"];
          }
          return {
            text: item["name"],
            value: item[".key"]
          };
        });
    },
    
  },
  methods: {
    openProd(item){
      this.selectedTodo =item; 
      this.invoiceTodo = true;
    },
    getFirmName(e){
      let firm;
        if (this.firms && this.selectedBrand) {
          firm =this.firms.filter(item => item['.key'] === e)[0]
        }
      if(firm)
        return firm.name
    },
    getCustomerName(id) {
      let buyer = this.buyerById[id];
      let seller = this.sellerById[id];
      if(!buyer && !seller) {
        return 'DELETED CUSTOMER'
      }
      return buyer ? buyer.name : seller.name;
    },
    addCustomer:function(e){
      let obj = {
        name :  e.target.value,
        brand : this.selectedBrand
      }
      if(this.selectedFirm) {
        obj['state'] = this.selectedFirm
      }

      if(this.isBuyer) {
        this.$root.$firebaseRefs.buyer.push(obj);
      } else {
        this.$root.$firebaseRefs.seller.push(obj);
      }
    },
    createInvoice(){
      let key = this.selectedTodo['.key'];
      delete this.selectedTodo['.key'];
      this.$root.$firebaseRefs.todos.child(key).set(this.selectedTodo).then((snap)=>{
        this.selectedTodo = null;
        this.$router.push({path: `/todo-to-invoice/${key}` })
        this.invoiceTodo = false;
      });
    },
    cancelTodo(todo){
        let key = todo['.key'];
        delete todo['.key'];
        todo['status'] = 'CANCELLED'
        this.$root.$firebaseRefs.todos.child(key).set(todo).then((snap)=>{
        });
    },
    editTodo(todo){
      this.productsToTodo = [];
      this.todoDialog = true;
      this.isEdit = true;
      this.firm = todo.firm;
      this.date = new Date(todo.date).toISOString().substr(0, 10),
      this.todoNumber = todo.todoNumber,
      this.todoContent = todo.todoContent
      this.selectedTodo = todo;
      this.isBuyer = todo.isBuyer;
      if(todo.isBuyer) {
        this.selectedBuyer = this.buyerById[todo.buyerId]
      } else {
        this.selectedBuyer = this.sellerById[todo.buyerId]
      }
    },
    addTodo(){
      let todoObj = {
        // buyerId : this.selectedBuyer['.key'],
        // isBuyer: this.isBuyer,
        firm: this.selectedFirm,
        brand: this.selectedBrand,
        date: new Date(this.date).getTime(),
        todoNumber: this.todoNumber,
        todoContent: this.todoContent,
        items: this.items,
      }
      if(this.isEdit ) {
        todoObj['status'] = this.selectedTodo['status']; 
        // todoObj['buyerId'] = this.selectedTodo['buyerId']; 
        this.$root.$firebaseRefs.todos.child(this.selectedTodo['.key']).set(todoObj).then((snap)=>{
            this.isEdit = false;
        });
      } else {
        todoObj['status'] = 'IN PROGRESS';
        this.$root.$firebaseRefs.todos.push(todoObj);
      }
      this.todoDialog = false;
      this.selectedBuyer = null;
      this.isBuyer = true;
      this.items = [];
    },
    deleteTodo(todo) {
      if (window.confirm("Do you want to Delete ?")) {
        this.$root.$firebaseRefs.todos.child(todo[".key"]).remove();
      }
    }
  }
};
</script>
<style>
.status-filter.v-select .v-select__selections, .status-filter.v-icon {
    color: #fff !important;
}
.status-filter.v-text-field > .v-input__control > .v-input__slot:before {
    border-color: #fff;
}
</style>
<style scoped>
.invoice-stepper {
  border: 1px solid #01579b;
  border-radius: 4px;
  background: #fafafa;
}
</style>




// WEBPACK FOOTER //
// src/components/Settings/Todo/todo.vue